/**
 * useModalStates — manages the 6 boolean modal/panel states from App.tsx.
 */

import { useState, useCallback } from 'react';

export function useModalStates() {
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const [isLibraryOpen, setIsLibraryOpen] = useState(false);
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const [isImportModalOpen, setIsImportModalOpen] = useState(false);
  const [isSessionMemoryOpen, setIsSessionMemoryOpen] = useState(false);
  const [isSaveSessionOpen, setIsSaveSessionOpen] = useState(false);

  const openSettings = useCallback(() => setIsSettingsOpen(true), []);
  const closeSettings = useCallback(() => setIsSettingsOpen(false), []);
  const toggleSettings = useCallback(() => setIsSettingsOpen(prev => !prev), []);
  const openLibrary = useCallback(() => setIsLibraryOpen(true), []);
  const closeLibrary = useCallback(() => setIsLibraryOpen(false), []);
  const toggleLibrary = useCallback(() => setIsLibraryOpen(prev => !prev), []);
  const openShare = useCallback(() => setIsShareModalOpen(true), []);
  const closeShare = useCallback(() => setIsShareModalOpen(false), []);
  const openImport = useCallback(() => setIsImportModalOpen(true), []);
  const closeImport = useCallback(() => setIsImportModalOpen(false), []);
  const openSessionMemory = useCallback(() => setIsSessionMemoryOpen(true), []);
  const closeSessionMemory = useCallback(() => setIsSessionMemoryOpen(false), []);
  const toggleSessionMemory = useCallback(() => setIsSessionMemoryOpen(prev => !prev), []);
  const openSaveSession = useCallback(() => setIsSaveSessionOpen(true), []);
  const closeSaveSession = useCallback(() => setIsSaveSessionOpen(false), []);

  return {
    isSettingsOpen, setIsSettingsOpen, openSettings, closeSettings, toggleSettings,
    isLibraryOpen, openLibrary, closeLibrary, toggleLibrary,
    isShareModalOpen, openShare, closeShare,
    isImportModalOpen, setIsImportModalOpen, openImport, closeImport,
    isSessionMemoryOpen, openSessionMemory, closeSessionMemory, toggleSessionMemory,
    isSaveSessionOpen, openSaveSession, closeSaveSession,
  };
}
